/* eslint no-underscore-dangle: 0 */

import { IconButton, ListItemText, Menu, MenuItem } from '@mui/material';

import MoreVertIcon from '@mui/icons-material/MoreVert';
import { useState } from 'react';

import useAlertDialog from 'hooks/common/useAlertDialog';
import useGQL from 'hooks/useGQL';

import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import ERoutes from 'routes/ERoutes';
import { openSnackbar } from 'store/slices/snackbar';
import Lang from '../../constants/language';

interface ActionMenuProps {
    promoCode: any;
    handleRefetch: any;
}

export const ActionMenu = (props: ActionMenuProps) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { promoCode, handleRefetch } = props;
    const { getConfirmation } = useAlertDialog();

    const { CHANGE_BRANDED_APP_PROMO_CODE_STATUS, DELETE_BRANDED_APP_PROMO_CODE } = useGQL();

    const [handleDeletePromoCode] = DELETE_BRANDED_APP_PROMO_CODE();
    const [handleChangeStatusPromoCode] = CHANGE_BRANDED_APP_PROMO_CODE_STATUS();

    const [anchorElAction, setAnchorElAction] = useState(null);
    const [selected, setSelected] = useState('');

    const handleMenuActionClick = (event: any, promoCodeId: string) => {
        setAnchorElAction(event?.currentTarget);
        setSelected(promoCodeId);
    };

    const handleActionClose = () => {
        setAnchorElAction(null);
        setSelected('');
    };

    const handleChangeStatus = async (event: any, promoCodeId: string, status: string) => {
        const isConfirm = await getConfirmation({
            title: Lang.MODAL_CHANGE_STATUS_TITLE('branded app promo code'),
            message: Lang.MODAL_CHANGE_STATUS_MESSAGE('branded app promo code')
        });

        handleActionClose();
        if (isConfirm) {
            try {
                const promoCodeChangedStatus = await handleChangeStatusPromoCode({
                    variables: {
                        input: {
                            isActive: status === 'active' ? false : true,
                            promoCodeId
                        }
                    }
                });
                handleRefetch();
                dispatch(
                    openSnackbar({
                        open: true,
                        message: promoCodeChangedStatus?.data?.changeBrandedAppPromoCodeStatus?.message,
                        anchorOrigin: { horizontal: 'center' },
                        variant: 'alert',
                        alert: {
                            color: 'success'
                        }
                    })
                );
            } catch (err: any) {
                dispatch(
                    openSnackbar({
                        open: true,
                        message: err?.message,
                        anchorOrigin: { horizontal: 'center' },
                        variant: 'alert',
                        alert: {
                            color: 'error'
                        }
                    })
                );
            }
        }
    };

    const handleDelete = async (promoCodeId: string) => {
        const isConfirm = await getConfirmation({
            title: Lang.MODAL_DELETE_TITLE('branded app promo code'),
            message: Lang.MODAL_DELETE_MESSAGE('branded app promo code')
        });

        handleActionClose();

        if (isConfirm) {
            try {
                const promoCodeDeletedStatus = await handleDeletePromoCode({
                    variables: {
                        input: {
                            promoCodeId
                        }
                    }
                });
                handleRefetch();
                dispatch(
                    openSnackbar({
                        open: true,
                        message: promoCodeDeletedStatus?.data?.deleteBrandedAppPromoCode?.message,
                        anchorOrigin: { horizontal: 'center' },
                        variant: 'alert',
                        alert: {
                            color: 'success'
                        }
                    })
                );
            } catch (err: any) {
                dispatch(
                    openSnackbar({
                        open: true,
                        message: err?.message,
                        anchorOrigin: { horizontal: 'center' },
                        variant: 'alert',
                        alert: {
                            color: 'error'
                        }
                    })
                );
            }
        }
    };

    return (
        <>
            <IconButton onClick={(e) => handleMenuActionClick(e, promoCode._id)} size="large">
                <MoreVertIcon fontSize="medium" aria-controls="menu-branded-app-promo" aria-haspopup="true" />
            </IconButton>
            <Menu
                id="menu-branded-app-promo"
                anchorEl={anchorElAction}
                keepMounted
                open={Boolean(anchorElAction)}
                onClose={handleActionClose}
                variant="selectedMenu"
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
            >
                <MenuItem>
                    <ListItemText
                        primary="Edit"
                        onClick={() => {
                            navigate(ERoutes.brandedAppPromoCodeEdit.replace(':id', promoCode._id));
                        }}
                    />
                </MenuItem>
                <MenuItem>
                    <ListItemText primary="Delete" onClick={() => handleDelete(promoCode._id)} />
                </MenuItem>
                <MenuItem>
                    <ListItemText
                        primary="Active/Inactive"
                        onClick={(event) => handleChangeStatus(event, promoCode._id, promoCode.status)}
                    />
                </MenuItem>
            </Menu>
        </>
    );
};
